var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.7143C8.20625 13.7143 10 11.6643 10 9.14286C10 6.62143 8.20625 4.57143 6 4.57143C3.79375 4.57143 2 6.62143 2 9.14286C2 11.6643 3.79375 13.7143 6 13.7143ZM34 13.7143C36.2062 13.7143 38 11.6643 38 9.14286C38 6.62143 36.2062 4.57143 34 4.57143C31.7938 4.57143 30 6.62143 30 9.14286C30 11.6643 31.7938 13.7143 34 13.7143ZM36 16H32C30.9 16 29.9062 16.5071 29.1812 17.3286C31.7 18.9071 33.4875 21.7571 33.875 25.1429H38C39.1063 25.1429 40 24.1214 40 22.8571V20.5714C40 18.05 38.2062 16 36 16ZM20 16C23.8687 16 27 12.4214 27 8C27 3.57857 23.8687 0 20 0C16.1313 0 13 3.57857 13 8C13 12.4214 16.1313 16 20 16ZM24.8 18.2857H24.2812C22.9813 19 21.5375 19.4286 20 19.4286C18.4625 19.4286 17.025 19 15.7188 18.2857H15.2C11.225 18.2857 8 21.9714 8 26.5143V28.5714C8 30.4643 9.34375 32 11 32H29C30.6562 32 32 30.4643 32 28.5714V26.5143C32 21.9714 28.775 18.2857 24.8 18.2857ZM10.8188 17.3286C10.0938 16.5071 9.1 16 8 16H4C1.79375 16 0 18.05 0 20.5714V22.8571C0 24.1214 0.89375 25.1429 2 25.1429H6.11875C6.5125 21.7571 8.3 18.9071 10.8188 17.3286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.cfa92af6957e4354e6052773f1034c98.svg";
export { ForwardRef as ReactComponent };